/** The first two CMS questions use laser / ink / unknown and low / medium / high volume. */
export function guideAdvice(printer: number | null, volume: number | null) {
  if (printer === 2) return { kind: 'unknown' as const };
  if (printer === null || volume === null) return { kind: 'incomplete' as const };

  const tips =
    printer === 1
      ? [
          'Pri občasnej tlači zvážte štandardnú kapacitu. Väčšie balenie atramentu sa oplatí len vtedy, ak ho stihnete využiť.',
          'Pri pravidelnej tlači porovnajte štandardnú a XL náplň podľa ceny za vytlačenú stranu.',
          'Pri častej tlači hľadajte XL alebo vysokokapacitnú náplň, ak ju váš model podporuje. Porovnajte cenu aj deklarovanú výťažnosť.',
        ]
      : [
          'Pri občasnej tlači môže stačiť štandardná kapacita. Vyššia výťažnosť má zmysel, ak toner postupne využijete.',
          'Pri pravidelnej tlači porovnajte štandardný a vysokokapacitný toner podľa ceny za vytlačenú stranu.',
          'Pri častej tlači sa zamerajte na vysokokapacitný toner. Porovnajte cenu za stranu a overte, či ho vaša tlačiareň podporuje.',
        ];
  return { kind: 'ready' as const, ink: printer === 1, tip: tips[volume] ?? tips[0] };
}

/** The image card and the main button must lead to the same printer-specific category. */
export function guideTarget(result: { href: string; printerHrefs: string[] }, printer: number) {
  return result.printerHrefs[printer] || result.href;
}
